export default "__VITE_ASSET__C250ukMe__"